export const config = {
    API_URL:'https://b.aa.clients.needle-digital.com/api/v1',
    DEFAULT_KEYWORDS: [],
    FETCH_TOKEN_URL: 'https://b.aa.clients.needle-digital.com/auth/tokens',
    AUTH_VERIFICATION_URL: 'https://b.aa.clients.needle-digital.com/auth/verify',
    COGNITO_AUTH_BASE_URL: 'https://aa-ndo.auth.ap-southeast-1.amazoncognito.com/',
    COGNITO_AUTH_LOGIN_ENDPOINT: 'login',
    COGNITO_CLIENT_ID: 's0d7det6o281kcv94p4p5tjop',
    COGNITO_RESPONSE_TYPE: 'code',
    COGNITO_REDIRECT_URL: 'https://aa.clients.needle-digital.com/auth/',
    LOGOUT_URL: 'https://b.aa.clients.needle-digital.com/auth/logout/',
    COGNITO_AUTH_LOGOUT_ENDPOINT: 'logout',
    COGNITO_LOGOUT_CALLBACK: 'https://aa.clients.needle-digital.com/'
}
